import React, {Component} from 'react';
import './feedback.css';
import axios from "axios";
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import ReCAPTCHA from "react-google-recaptcha";
import personal from "../../../files/Политика_в_отношении_обработки_персональных.pdf";
import user from "../../../files/Пользовательское Соглашение.pdf";
import consent from "../../../files/Согласие_на_обработку_персональных.pdf";
import Spinner from 'react-bootstrap/Spinner';

const recaptchaRef = React.createRef<any>();

interface FeedbackState {
    recaptchaToken?: string;
    name?: string;
    email?: string;
    phoneNumber?: string;
    result?: string;
    loading?: boolean;
}

interface FeedbackProps {
    recaptchaToken?: string;
    name?: string;
    email?: string;
    phoneNumber?: string;
    result?: string;
    loading?: boolean;
}

export default class Feedback extends Component<FeedbackProps, FeedbackState> {
    constructor(props: FeedbackProps) {
        super(props);
        this.state = {
            recaptchaToken: this.props.recaptchaToken,
            name: this.props.name,
            email: this.props.email,
            phoneNumber: this.props.phoneNumber,
            result: this.props.result,
            loading: this.props.loading,
        }
    }

    onSubmit = () => {
        const name = document.getElementById('name') as HTMLInputElement | null;
        const email = document.getElementById('email') as HTMLInputElement | null;
        const company = document.getElementById('company') as HTMLInputElement | null;
        const phoneNumber = document.getElementById('phone_number') as HTMLInputElement | null;
        const comment = document.getElementById('comment') as HTMLInputElement | null;

        const nameValue = name?.value.trim() ?? '';
        const emailValue = email?.value.trim() ?? '';
        const companyValue = company?.value.trim() ?? '';
        const phoneNumberValue = phoneNumber?.value.trim() ?? '';
        const commentValue = comment?.value.trim() ?? '';

        const feedback: Record<string, string> = {};
        const {recaptchaToken} = this.state;
        if (!recaptchaToken) {
            alert('А Вы точно не робот?');
            return;
        }
        feedback.recaptcha_token = recaptchaToken;
        if (!nameValue) {
            alert('Как к Вам можно обращаться?');
            return
        }
        feedback.name = nameValue;
        if (!emailValue) {
            alert('Какая у Вас почта?');
            return
        }
        feedback.email = emailValue;
        if (companyValue) {
            feedback.company = companyValue
        }
        if (phoneNumberValue) {
            feedback.phone_number = phoneNumberValue
        }
        if (commentValue) {
            feedback.comment = commentValue
        }
        this.setState({ loading: true })

        axios.post(`/api/v3/feedback`, feedback).then(res => {
            this.setState({result: 'Спасибо! Наш специалист свяжется с Вами в ближайшее время', loading: false});
        }).catch((error) => {
            this.setState({result: 'Сейчас на нашем сервере проблемы. Для связи с нами напишите, пожалуйста, на welcome@labrahub.com', loading: false});
        });
    };

    submitEnabled = () => {
        const {recaptchaToken, name, email} = this.state;
        return !!recaptchaToken && !!name && !!email;
    };

    render() {
        const disabled = !this.submitEnabled();

        return (
            <div className="feedback-container">
                {this.state.result ? <h3 id="result" className="result" style={{textAlign: 'center'}}>{this.state.result}</h3> :
                    <div className="feedback-fields">
                        <form noValidate autoComplete="off">
                            <TextField
                                required id="name"
                                type="text"
                                label="Как к Вам можно обращаться?"
                                fullWidth={true}
                                onChange={e => this.setState({name: e.target.value})}
                            />
                            <TextField
                                required id="email"
                                type="email"
                                label="Email"
                                fullWidth={true}
                                onChange={e => this.setState({email: e.target.value})}
                            />
                            <TextField
                                id="company"
                                type="text"
                                label="Компания"
                                fullWidth={true}
                            />
                            <div className="phone-number">
                                <PhoneInput
                                    id="phone_number"
                                    placeholder="Телефон (необязательно)"
                                    country="RU"
                                    showCountrySelect={false}
                                    value={this.state.phoneNumber}
                                    onChange={(phoneNumber: string | undefined) => this.setState({phoneNumber: phoneNumber ?? undefined})}
                                    fullWidth={true}
                                />
                            </div>
                            <TextField
                                id="comment"
                                type="text"
                                label="Комментарий/вопрос"
                                fullWidth={true}
                                multiline
                                rows={2}
                            />
                            <div className="recaptcha">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6LfjnsYUAAAAAPyyWJtrTLWx7yUErtXh1XuqlaLa"
                                    onChange={(recaptchaToken: string | null) => this.setState({recaptchaToken: recaptchaToken ?? undefined})}
                                />
                                <p>Нажимая Отправить вы соглашаетесь с <a href={user}>пользовательским
                                    соглашением</a> и <a href={personal}>политикой
                                    обработки персональных данных</a>, а также выражаете <a href={consent}>согласие на
                                    их обработку</a></p>
                            </div>
                            <div className="feedback-button">
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    {this.state.loading ? <Spinner animation={"border"} /> : <Button
                                        style={{
                                            backgroundColor: disabled ? "#85929e" : "#ff005c",
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: "bolder"
                                        }}
                                        variant="contained"
                                        color="primary"
                                        onClick={this.onSubmit}
                                        disabled={disabled}
                                    >
                                        Отправить
                                    </Button>}
                                </div>
                            </div>
                        </form>
                    </div>}
            </div>
        );
    };
}
